import React from 'react';

export const TrashIcon = ({ color = '#444444', ...restProps }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M2.5 5.14307H4.16667H17.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 5.14303V3.47636C6.66699 3.03433 6.84259 2.61041 7.15515 2.29785C7.46771 1.98529 7.89163 1.80969 8.33366 1.80969H11.667C12.109 1.80969 12.5329 1.98529 12.8455 2.29785C13.1581 2.61041 13.3337 3.03433 13.3337 3.47636V5.14303M15.8337 5.14303V16.8097C15.8337 17.2517 15.6581 17.6756 15.3455 17.9882C15.0329 18.3008 14.609 18.4764 14.167 18.4764H5.83366C5.39163 18.4764 4.96771 18.3008 4.65515 17.9882C4.34259 17.6756 4.16699 17.2517 4.16699 16.8097V5.14303H15.8337Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33301 9.30969V14.3097"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 9.30969V14.3097"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
